import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { GeneralCandidateCard } from 'features/candidate/components/Candidates/Cards'

export const Grid = ({ items, ...props }) => {
  const { t } = useTranslation()

  return (
    <>
      {items.map((item, i) => (
        <Row key={i}>
          <Col>
            <GeneralCandidateCard
              data={item}
              actionBarProps={{ config: { scheduleLink: true } }}
              asMentor
              {...props}
            />
          </Col>
        </Row>
      ))}
    </>
  )
}

Grid.propTypes = {
  items: PropTypes.array,
}
